import { useState } from "react";

// ─────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────
const HARI = ["Senin","Selasa","Rabu","Kamis","Jumat","Sabtu","Minggu"];

const LV = {
  Helper:  { c:"#6B7280", bg:"#F3F4F6" },
  Junior:  { c:"#3B82F6", bg:"#EFF6FF" },
  Senior:  { c:"#8B5CF6", bg:"#F5F3FF" },
  Master:  { c:"#F59E0B", bg:"#FFFBEB" },
};

const KP = { Simple:"#10B981", Medium:"#3B82F6", Large:"#8B5CF6", Complex:"#EF4444" };

const SOP_ITEMS = {
  persiapan: ["Konfirmasi kesiapan: sudah reply SIAP di WAG Admin","Bawa obeng, bor listrik, palu, meteran, tang, kunci L, cutter, kain lap","Berpakaian rapi dan sopan","Berangkat maks 15 menit sebelum jadwal","Dilarang bawa orang lain atau merokok sembarangan"],
  checkin:   ["Tiba di lokasi → pengecekan barang & kelengkapan part","Foto WAJIB: kondisi awal & kelengkapan part","Konfirmasi item yang akan dirakit bersama klien","Pastikan kondisi aman sebelum mulai bekerja"],
  eksekusi:  ["Ikuti petunjuk manual rakitan secara presisi","Kerja rapi, aman, tidak terburu-buru demi kualitas","Jaga kebersihan area kerja klien selama pengerjaan","DILARANG: mengubah desain tanpa persetujuan Admin","DILARANG: menawarkan jasa pribadi ke klien","DILARANG: menerima uang langsung dari klien"],
  serahterima:["Furniture dirakit dengan kokoh dan sempurna","Semua baut & kelengkapan terpasang sempurna","Area kerja klien sudah dibersihkan kembali","Tunjukkan hasil akhir kepada klien","Ambil Foto Hasil Akhir dan kirim ke Admin","Jika klien komplain: JANGAN BERDEBAT, laporkan ke Admin"],
};

const INIT = {
  tukang: [
    { id:1, nama:"Budi Santoso",   tel:"08123456789", level:"Senior", kota:"Yogyakarta", skor:92, proyek:28, penghasilan:4500000,  status:"Aktif", rek:"BCA 1234567890",    joined:"2023-01-15", jadwal:["Senin","Selasa","Rabu","Kamis"] },
    { id:2, nama:"Andi Prasetyo",  tel:"08234567890", level:"Junior", kota:"Yogyakarta", skor:78, proyek:8,  penghasilan:1200000,  status:"Aktif", rek:"BRI 0987654321",    joined:"2023-06-20", jadwal:["Rabu","Kamis","Jumat"] },
    { id:3, nama:"Rudi Hartono",   tel:"08345678901", level:"Helper", kota:"Solo",       skor:65, proyek:3,  penghasilan:350000,   status:"Aktif", rek:"Mandiri 1122334455",joined:"2024-01-10", jadwal:["Senin","Rabu","Jumat"] },
    { id:4, nama:"Siti Rahayu",    tel:"08456789012", level:"Master", kota:"Yogyakarta", skor:97, proyek:45, penghasilan:12000000, status:"Aktif", rek:"BCA 9988776655",    joined:"2022-03-05", jadwal:["Senin","Selasa","Rabu","Kamis","Jumat"] },
  ],
  klien: [
    { id:1, nama:"Dewi Lestari",   tel:"08567890123", alamat:"Jl. Kaliurang No.12, Yogyakarta", email:"dewi@email.com",         kota:"Yogyakarta" },
    { id:2, nama:"PT. Griya Indah",tel:"02741234567", alamat:"Jl. Malioboro No.45, Yogyakarta", email:"info@griyaindah.co.id", kota:"Yogyakarta" },
  ],
  order: [
    { id:1, klien:"Dewi Lestari",   alamat:"Jl. Kaliurang No.12", tgl:"2025-05-15", komp:"Medium",  item:"Lemari 3 pintu + Meja kerja",   nilai:500000,  status:"Selesai",  tim:[{id:1,role:"Lead"},{id:2,role:"Anggota"}], catatan:"",              kota:"Yogyakarta", bayar:"Lunas" },
    { id:2, klien:"PT. Griya Indah",alamat:"Jl. Malioboro No.45", tgl:"2025-05-18", komp:"Complex", item:"Kitchen Set penuh + Island",     nilai:1200000, status:"Berjalan", tim:[{id:4,role:"Lead"},{id:1,role:"Anggota"}], catatan:"Hati-hati granit",kota:"Yogyakarta", bayar:"Belum" },
  ],
  keuangan: [
    { id:1, order_id:1, tgl:"2025-05-15", total:500000, office:125000, tukang_total:375000, status:"Cair", cair_tgl:"2025-05-17",
      upah:[{tid:1,nama:"Budi Santoso",role:"Lead",pct:50,nom:187500},{tid:2,nama:"Andi Prasetyo",role:"Anggota",pct:30,nom:112500}] },
  ],
  pembukuan: [
    { id:1, tgl:"2025-05-01", jenis:"pemasukan",  kategori:"Jasa Rakit",   keterangan:"Order Dewi Lestari",            jumlah:500000, status:"Lunas",       pihak:"" },
    { id:2, tgl:"2025-05-03", jenis:"pengeluaran", kategori:"Operasional",  keterangan:"Beli mata bor & sekrup",        jumlah:85000,  status:"Lunas",       pihak:"" },
    { id:3, tgl:"2025-05-10", jenis:"piutang",     kategori:"Tagihan Klien",keterangan:"Sisa pembayaran PT Griya Indah",jumlah:300000, status:"Belum Lunas", pihak:"PT. Griya Indah" },
    { id:4, tgl:"2025-05-12", jenis:"hutang",      kategori:"Supplier",     keterangan:"Pinjam alat bor ke Pak Hendra", jumlah:150000, status:"Belum Lunas", pihak:"Pak Hendra" },
  ],
};

// ─────────────────────────────────────────────
// UTILS
// ─────────────────────────────────────────────
function getRating(s) {
  if (s >= 90) return { l:"GOLD",      c:"#F59E0B", bg:"#FFFBEB", hak:"Prioritas utama order, eligible bonus" };
  if (s >= 75) return { l:"SILVER",    c:"#6B7280", bg:"#F9FAFB", hak:"Order normal, bisa upgrade ke Gold" };
  if (s >= 60) return { l:"WARNING",   c:"#EF4444", bg:"#FEF2F2", hak:"Order dibatasi, wajib evaluasi" };
  return        { l:"BLACKLIST", c:"#111827",bg:"#F3F4F6", hak:"Pemutusan kemitraan permanen" };
}
function rp(n)  { return "Rp " + (Math.round(n) || 0).toLocaleString("id-ID"); }
function fd(d)  { if (!d) return "-"; try { return new Date(d + "T12:00:00").toLocaleDateString("id-ID",{day:"2-digit",month:"short",year:"numeric"}); } catch { return d; } }
function getDayName(dateStr) {
  if (!dateStr) return "";
  const days = ["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"];
  return days[new Date(dateStr + "T12:00:00").getDay()];
}
// Formula keuangan: <200rb → 20% office / 80% tukang; ≥200rb → 25% office / 75% tukang
function hitungUpah(nilaiTotal, tim, tukangList) {
  if (!tim || !tim.length) return { upah:[], office:0, tukang_total:0 };
  const tukangPct = nilaiTotal < 200000 ? 0.80 : 0.75;
  const tb = Math.round(nilaiTotal * tukangPct);
  const ob = nilaiTotal - tb;
  const upah = tim.map(({ id, role }) => {
    const tk = tukangList.find(t => t.id === id); if (!tk) return null;
    const n = tim.length;
    const pct = n === 1 ? 100 : n === 2 ? (role==="Lead"?50:role==="Helper"?20:30) : (role==="Lead"?50:role==="Helper"?20:30);
    return { tid:id, nama:tk.nama, role, pct, nom:Math.round(tb*pct/100) };
  }).filter(Boolean);
  return { upah, office:ob, tukang_total:tb };
}
// Cari tukang tersedia pada hari tertentu, sorted by skor
function getTukangTersedia(tukangList, hariStr) {
  return tukangList
    .filter(t => t.status === "Aktif" && (t.jadwal || []).includes(hariStr))
    .sort((a, b) => b.skor - a.skor);
}

// ─────────────────────────────────────────────
// SHARED UI COMPONENTS
// ─────────────────────────────────────────────
function Badge({ label, color, bg }) {
  return <span style={{ background:bg, color, border:`1px solid ${color}22`, padding:"2px 9px", borderRadius:20, fontSize:11, fontWeight:600 }}>{label}</span>;
}
function Card({ children, style={} }) {
  return <div style={{ background:"var(--color-background-primary)", borderRadius:12, border:"0.5px solid var(--color-border-tertiary)", padding:16, ...style }}>{children}</div>;
}
function Btn({ label, variant="p", onClick, style={}, disabled }) {
  const cs = { p:"background:#1D4ED8;color:#fff;border:none", s:"background:#059669;color:#fff;border:none", d:"background:#DC2626;color:#fff;border:none", g:"background:var(--color-background-secondary);color:var(--color-text-primary);border:0.5px solid var(--color-border-secondary)", w:"background:#D97706;color:#fff;border:none" };
  return <button onClick={onClick} disabled={disabled} style={{ ...(Object.fromEntries((cs[variant]||cs.p).split(";").filter(Boolean).map(s=>[s.split(":")[0].trim(),s.split(":").slice(1).join(":").trim()]))), padding:"7px 14px", borderRadius:8, fontSize:12, fontWeight:600, cursor:disabled?"not-allowed":"pointer", opacity:disabled?0.5:1, ...style }}>{label}</button>;
}
function Modal({ open, onClose, title, children, width=500 }) {
  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"#00000060", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:12 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:"var(--color-background-primary)", borderRadius:14, width:"100%", maxWidth:width, maxHeight:"88vh", overflow:"auto" }}>
        <div style={{ padding:"18px 20px 14px", borderBottom:"0.5px solid var(--color-border-tertiary)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div style={{ fontSize:15, fontWeight:600, color:"var(--color-text-primary)" }}>{title}</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer", color:"var(--color-text-secondary)" }}>×</button>
        </div>
        <div style={{ padding:20 }}>{children}</div>
      </div>
    </div>
  );
}
function Inp({ label, ...props }) {
  return <div style={{ marginBottom:10 }}>
    {label && <label style={{ display:"block", fontSize:11, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:3 }}>{label}</label>}
    <input style={{ width:"100%", padding:"7px 10px", border:"1px solid var(--color-border-secondary)", borderRadius:7, fontSize:12, background:"var(--color-background-primary)", color:"var(--color-text-primary)" }} {...props} />
  </div>;
}
function Sel({ label, children, ...props }) {
  return <div style={{ marginBottom:10 }}>
    {label && <label style={{ display:"block", fontSize:11, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:3 }}>{label}</label>}
    <select style={{ width:"100%", padding:"7px 10px", border:"1px solid var(--color-border-secondary)", borderRadius:7, fontSize:12, background:"var(--color-background-primary)", color:"var(--color-text-primary)" }} {...props}>{children}</select>
  </div>;
}
function StatCard({ icon, label, value, color }) {
  return <Card style={{ display:"flex", alignItems:"center", gap:12 }}>
    <div style={{ width:42, height:42, borderRadius:10, background:`${color}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>{icon}</div>
    <div><div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>{label}</div><div style={{ fontSize:18, fontWeight:600, color:"var(--color-text-primary)" }}>{value}</div></div>
  </Card>;
}

// ─────────────────────────────────────────────
// DASHBOARD
// ─────────────────────────────────────────────
function Dashboard({ data }) {
  const omset = data.order.filter(o=>o.status==="Selesai").reduce((s,o)=>s+o.nilai,0);
  const officeTotal = data.keuangan.reduce((s,k)=>s+(k.office||0),0);
  const gold = data.tukang.filter(t=>t.skor>=90).length;
  return (
    <div>
      <div style={{ marginBottom:14 }}><div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Dashboard</div><div style={{ fontSize:12, color:"var(--color-text-secondary)" }}>Sistem operasional Rakitin.pro</div></div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:14 }}>
        <StatCard icon="💰" label="Total omset selesai" value={rp(omset)} color="#059669" />
        <StatCard icon="🏢" label="Pendapatan office" value={rp(officeTotal)} color="#8B5CF6" />
        <StatCard icon="🔧" label="Order berjalan" value={data.order.filter(o=>o.status==="Berjalan").length} color="#D97706" />
        <StatCard icon="⭐" label="Tukang Gold" value={gold + " orang"} color="#F59E0B" />
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
        <Card>
          <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:10 }}>Order terbaru</div>
          {[...data.order].reverse().map(o => {
            const sc = o.status==="Selesai"?"#059669":o.status==="Berjalan"?"#1D4ED8":"#D97706";
            const sbg = o.status==="Selesai"?"#D1FAE5":o.status==="Berjalan"?"#DBEAFE":"#FEF3C7";
            return <div key={o.id} style={{ padding:"7px 0", borderBottom:"0.5px solid var(--color-border-tertiary)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div><div style={{ fontSize:12, fontWeight:500, color:"var(--color-text-primary)" }}>{o.klien}</div><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>{o.item.substring(0,24)}</div></div>
              <div style={{ textAlign:"right" }}><div style={{ fontSize:12, fontWeight:600, color:"#059669" }}>{rp(o.nilai)}</div><span style={{ fontSize:10, padding:"1px 6px", borderRadius:8, background:sbg, color:sc }}>{o.status}</span></div>
            </div>;
          })}
        </Card>
        <Card>
          <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:10 }}>Formula pembagian upah</div>
          <div style={{ background:"#EFF6FF", borderRadius:8, padding:10, marginBottom:8 }}>
            <div style={{ fontSize:10, color:"#1D4ED8", fontWeight:600, marginBottom:5 }}>Order &lt; Rp 200.000</div>
            <div style={{ display:"flex", gap:6 }}>
              <div style={{ flex:1, background:"#fff", borderRadius:6, padding:7, textAlign:"center" }}><div style={{ fontSize:16, fontWeight:700, color:"#8B5CF6" }}>20%</div><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>Office</div></div>
              <div style={{ flex:1, background:"#fff", borderRadius:6, padding:7, textAlign:"center" }}><div style={{ fontSize:16, fontWeight:700, color:"#059669" }}>80%</div><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>Tukang</div></div>
            </div>
          </div>
          <div style={{ background:"#F5F3FF", borderRadius:8, padding:10 }}>
            <div style={{ fontSize:10, color:"#8B5CF6", fontWeight:600, marginBottom:5 }}>Order ≥ Rp 200.000</div>
            <div style={{ display:"flex", gap:6 }}>
              <div style={{ flex:1, background:"#fff", borderRadius:6, padding:7, textAlign:"center" }}><div style={{ fontSize:16, fontWeight:700, color:"#8B5CF6" }}>25%</div><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>Office</div></div>
              <div style={{ flex:1, background:"#fff", borderRadius:6, padding:7, textAlign:"center" }}><div style={{ fontSize:16, fontWeight:700, color:"#059669" }}>75%</div><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>Tukang</div></div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// TUKANG (+ JADWAL KETERSEDIAAN)
// ─────────────────────────────────────────────
function Tukang({ data, setData }) {
  const [modal, setModal] = useState(false);
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState({ nama:"", tel:"", level:"Helper", kota:"", rek:"", status:"Aktif", jadwal:[] });
  const [detail, setDetail] = useState(null);

  const openAdd = () => { setEdit(null); setForm({ nama:"", tel:"", level:"Helper", kota:"Yogyakarta", rek:"", status:"Aktif", jadwal:[] }); setModal(true); };
  const openEdit = t => { setEdit(t); setForm({ nama:t.nama, tel:t.tel, level:t.level, kota:t.kota, rek:t.rek, status:t.status, jadwal:[...(t.jadwal||[])] }); setModal(true); };
  const toggleHari = h => setForm(f => ({ ...f, jadwal: f.jadwal.includes(h) ? f.jadwal.filter(x=>x!==h) : [...f.jadwal, h] }));
  const save = () => {
    if (!form.nama || !form.tel) { alert("Nama dan telepon wajib"); return; }
    if (edit) setData(d => ({ ...d, tukang: d.tukang.map(t => t.id===edit.id ? {...t,...form} : t) }));
    else setData(d => ({ ...d, tukang: [...d.tukang, {...form, id:Date.now(), skor:70, proyek:0, penghasilan:0, joined:new Date().toISOString().split("T")[0]}] }));
    setModal(false);
  };
  const adj = (id, delta) => setData(d => ({ ...d, tukang: d.tukang.map(t => t.id===id ? {...t, skor:Math.min(100,Math.max(0,t.skor+delta))} : t) }));

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Manajemen tukang</div>
        <Btn label="+ Tambah tukang" onClick={openAdd} />
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:11 }}>
        {data.tukang.map(t => {
          const r = getRating(t.skor); const lv = LV[t.level];
          return (
            <Card key={t.id}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:9 }}>
                <div style={{ display:"flex", alignItems:"center", gap:9 }}>
                  <div style={{ width:38, height:38, borderRadius:"50%", background:lv.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:17 }}>👷</div>
                  <div><div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>{t.nama}</div><div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>📍 {t.kota}</div></div>
                </div>
                <div style={{ textAlign:"right" }}><Badge label={r.l} color={r.c} bg={r.bg} /><div style={{ fontSize:22, fontWeight:700, color:r.c, marginTop:3 }}>{t.skor}</div></div>
              </div>
              <div style={{ display:"flex", gap:5, marginBottom:9 }}>
                <Badge label={t.level} color={lv.c} bg={lv.bg} />
                <Badge label={t.status} color={t.status==="Aktif"?"#059669":"#DC2626"} bg={t.status==="Aktif"?"#D1FAE5":"#FEE2E2"} />
              </div>
              {/* Jadwal Ketersediaan */}
              <div style={{ marginBottom:9 }}>
                <div style={{ fontSize:10, color:"var(--color-text-secondary)", fontWeight:600, marginBottom:4 }}>📅 Ketersediaan:</div>
                <div style={{ display:"flex", gap:3, flexWrap:"wrap" }}>
                  {HARI.map(h => {
                    const avail = (t.jadwal||[]).includes(h);
                    return <span key={h} style={{ fontSize:9, padding:"2px 6px", borderRadius:10, background:avail?"#D1FAE5":"var(--color-background-secondary)", color:avail?"#059669":"var(--color-text-secondary)", fontWeight:avail?600:400 }}>{h.substring(0,3)}</span>;
                  })}
                </div>
              </div>
              <div style={{ fontSize:11, color:"var(--color-text-secondary)", display:"grid", gridTemplateColumns:"1fr 1fr", gap:3, marginBottom:10 }}>
                <span>📦 {t.proyek} proyek</span><span>💰 {rp(t.penghasilan)}</span>
              </div>
              <div style={{ display:"flex", gap:5 }}>
                <Btn label="Detail" variant="g" onClick={()=>setDetail(t)} style={{ flex:1, fontSize:11, padding:"5px 6px" }} />
                <Btn label="Edit"   variant="g" onClick={()=>openEdit(t)} style={{ flex:1, fontSize:11, padding:"5px 6px" }} />
                <button onClick={()=>adj(t.id,5)}  style={{ background:"#D1FAE5", color:"#059669", border:"none", borderRadius:7, padding:"5px 9px", fontWeight:700, fontSize:12, cursor:"pointer" }}>+5</button>
                <button onClick={()=>adj(t.id,-5)} style={{ background:"#FEE2E2", color:"#DC2626", border:"none", borderRadius:7, padding:"5px 9px", fontWeight:700, fontSize:12, cursor:"pointer" }}>-5</button>
              </div>
            </Card>
          );
        })}
      </div>

      {/* Modal Tambah/Edit */}
      <Modal open={modal} onClose={()=>setModal(false)} title={edit?"Edit tukang":"Tambah tukang"}>
        <Inp label="Nama lengkap" value={form.nama} onChange={e=>setForm(f=>({...f,nama:e.target.value}))} />
        <Inp label="Telepon" value={form.tel} onChange={e=>setForm(f=>({...f,tel:e.target.value}))} placeholder="08xxx" />
        <Sel label="Level" value={form.level} onChange={e=>setForm(f=>({...f,level:e.target.value}))}>
          {Object.keys(LV).map(l=><option key={l}>{l}</option>)}
        </Sel>
        <Inp label="Kota" value={form.kota} onChange={e=>setForm(f=>({...f,kota:e.target.value}))} placeholder="Yogyakarta" />
        <Inp label="Nomor rekening" value={form.rek} onChange={e=>setForm(f=>({...f,rek:e.target.value}))} placeholder="BCA 1234567890" />
        <Sel label="Status" value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))}>
          <option>Aktif</option><option>Non-Aktif</option><option>Blacklist</option>
        </Sel>
        {/* Jadwal Ketersediaan */}
        <div style={{ marginBottom:12 }}>
          <label style={{ display:"block", fontSize:11, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:6 }}>📅 Jadwal ketersediaan (pilih hari)</label>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
            {HARI.map(h => {
              const sel = form.jadwal.includes(h);
              return <button key={h} type="button" onClick={()=>toggleHari(h)} style={{ padding:"5px 10px", borderRadius:20, border:`1.5px solid ${sel?"#059669":"var(--color-border-secondary)"}`, background:sel?"#D1FAE5":"var(--color-background-secondary)", color:sel?"#059669":"var(--color-text-secondary)", fontSize:12, fontWeight:sel?600:400, cursor:"pointer" }}>{h}</button>;
            })}
          </div>
        </div>
        <div style={{ display:"flex", gap:8, marginTop:6 }}>
          <Btn label="💾 Simpan" onClick={save} style={{ flex:1 }} />
          <Btn label="Batal" variant="g" onClick={()=>setModal(false)} style={{ flex:1 }} />
        </div>
      </Modal>

      {/* Modal Detail */}
      <Modal open={!!detail} onClose={()=>setDetail(null)} title="Detail tukang" width={440}>
        {detail && (() => {
          const r = getRating(detail.skor); const lv = LV[detail.level];
          const ot = data.order.filter(o=>o.tim?.some(m=>m.id===detail.id));
          return (
            <div>
              <div style={{ textAlign:"center", marginBottom:14 }}>
                <div style={{ width:50, height:50, borderRadius:"50%", background:lv.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, margin:"0 auto 9px" }}>👷</div>
                <div style={{ fontSize:16, fontWeight:600, color:"var(--color-text-primary)" }}>{detail.nama}</div>
                <div style={{ display:"flex", gap:7, justifyContent:"center", marginTop:6 }}><Badge label={detail.level} color={lv.c} bg={lv.bg} /> <Badge label={r.l} color={r.c} bg={r.bg} /></div>
              </div>
              <div style={{ textAlign:"center", background:"var(--color-background-secondary)", borderRadius:10, padding:12, marginBottom:12 }}>
                <div style={{ fontSize:44, fontWeight:700, color:r.c }}>{detail.skor}</div>
                <div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>Skor performa</div>
              </div>
              <div style={{ background:r.bg, border:`1px solid ${r.c}30`, borderRadius:8, padding:10, fontSize:12, color:r.c, marginBottom:12 }}><b>Hak:</b> {r.hak}</div>
              <Card style={{ marginBottom:12 }}>
                <div style={{ fontSize:11, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:8 }}>📅 Jadwal ketersediaan</div>
                <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
                  {HARI.map(h => {
                    const avail = (detail.jadwal||[]).includes(h);
                    return <span key={h} style={{ fontSize:12, padding:"4px 10px", borderRadius:16, background:avail?"#D1FAE5":"var(--color-background-secondary)", color:avail?"#059669":"var(--color-text-secondary)", fontWeight:avail?600:400 }}>{h}</span>;
                  })}
                </div>
              </Card>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:7, marginBottom:12 }}>
                {[["Total proyek",detail.proyek],["Penghasilan",rp(detail.penghasilan)],["Telepon",detail.tel],["Rekening",detail.rek||"-"]].map(([k,v])=>(
                  <div key={k} style={{ background:"var(--color-background-secondary)", borderRadius:7, padding:8 }}><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>{k}</div><div style={{ fontSize:12, fontWeight:500, color:"var(--color-text-primary)" }}>{v}</div></div>
                ))}
              </div>
              <div style={{ marginBottom:12 }}>
                <div style={{ fontSize:12, fontWeight:600, color:"var(--color-text-primary)", marginBottom:7 }}>Riwayat order ({ot.length})</div>
                {ot.slice(0,3).map(o=><div key={o.id} style={{ padding:"5px 0", borderBottom:"0.5px solid var(--color-border-tertiary)", fontSize:12, color:"var(--color-text-primary)" }}><b>{o.klien}</b> — {o.item} — <span style={{ color:"#059669" }}>{rp(o.nilai)}</span></div>)}
                {ot.length===0&&<div style={{ fontSize:12, color:"var(--color-text-secondary)" }}>Belum ada riwayat</div>}
              </div>
              <Btn label="Tutup" variant="g" onClick={()=>setDetail(null)} style={{ width:"100%" }} />
            </div>
          );
        })()}
      </Modal>
    </div>
  );
}

// ─────────────────────────────────────────────
// ORDER (dengan rekomendasi tukang otomatis)
// ─────────────────────────────────────────────
function Order({ data, setData }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ klien:"", alamat:"", tgl:"", komp:"Simple", item:"", nilai:"", kota:"Yogyakarta", catatan:"", tim:[], bayar:"Belum" });
  const [filter, setFilter] = useState("Semua");
  const [detail, setDetail] = useState(null);

  const hariOrder = getDayName(form.tgl);
  const rekomendasiTukang = hariOrder ? getTukangTersedia(data.tukang, hariOrder) : [];

  const addTim = () => setForm(f=>({...f, tim:[...f.tim,{id:"",role:"Anggota"}]}));
  const remTim = i => setForm(f=>({...f, tim:f.tim.filter((_,j)=>j!==i)}));
  const updTim = (i,field,val) => setForm(f=>({...f, tim:f.tim.map((m,j)=>j===i?{...m,[field]:field==="id"?parseInt(val):val}:m)}));
  const addRekomendasi = t => {
    if (form.tim.some(m=>m.id===t.id)) return;
    const role = form.tim.length===0?"Lead":"Anggota";
    setForm(f=>({...f, tim:[...f.tim,{id:t.id,role}]}));
  };

  const save = () => {
    if (!form.klien||!form.tgl||!form.nilai) { alert("Lengkapi data order"); return; }
    setData(d=>({...d, order:[...d.order,{...form,id:Date.now(),nilai:parseInt(form.nilai),status:"Terjadwal"}]}));
    setModal(false);
    setForm({ klien:"", alamat:"", tgl:"", komp:"Simple", item:"", nilai:"", kota:"Yogyakarta", catatan:"", tim:[], bayar:"Belum" });
  };

  const sim = hitungUpah(parseInt(form.nilai)||0, form.tim, data.tukang);
  const filtered = filter==="Semua" ? data.order : data.order.filter(o=>o.status===filter);

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
        <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Manajemen order</div>
        <Btn label="+ Order baru" onClick={()=>setModal(true)} />
      </div>
      <div style={{ display:"flex", gap:6, marginBottom:12, flexWrap:"wrap" }}>
        {["Semua","Terjadwal","Berjalan","Selesai"].map(s=>(
          <button key={s} onClick={()=>setFilter(s)} style={{ padding:"5px 12px", borderRadius:16, border:"1px solid", borderColor:filter===s?"#1D4ED8":"var(--color-border-tertiary)", background:filter===s?"#EFF6FF":"var(--color-background-primary)", color:filter===s?"#1D4ED8":"var(--color-text-primary)", fontSize:12, fontWeight:filter===s?600:400, cursor:"pointer" }}>
            {s}{s!=="Semua"?` (${data.order.filter(o=>o.status===s).length})`:""}
          </button>
        ))}
      </div>
      {filtered.map(o=>{
        const sc=o.status==="Selesai"?"#059669":o.status==="Berjalan"?"#1D4ED8":"#D97706";
        const sbg=o.status==="Selesai"?"#D1FAE5":o.status==="Berjalan"?"#DBEAFE":"#FEF3C7";
        const hariO = getDayName(o.tgl);
        return (
          <Card key={o.id} style={{ marginBottom:10 }}>
            <div style={{ display:"flex", justifyContent:"space-between", gap:10 }}>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap", marginBottom:5 }}>
                  <span style={{ fontSize:14, fontWeight:600, color:"var(--color-text-primary)" }}>{o.klien}</span>
                  <span style={{ background:`${KP[o.komp]||"#6B7280"}18`, color:KP[o.komp]||"#6B7280", padding:"1px 7px", borderRadius:5, fontSize:11, fontWeight:600 }}>{o.komp}</span>
                  <span style={{ padding:"1px 7px", borderRadius:5, fontSize:11, fontWeight:600, background:sbg, color:sc }}>{o.status}</span>
                  {hariO && <span style={{ background:"#F5F3FF", color:"#8B5CF6", padding:"1px 7px", borderRadius:5, fontSize:11, fontWeight:600 }}>📅 {hariO}</span>}
                </div>
                <div style={{ fontSize:12, color:"var(--color-text-primary)" }}>📦 {o.item}</div>
                <div style={{ fontSize:11, color:"var(--color-text-secondary)", marginTop:3 }}>📍 {o.alamat} · {fd(o.tgl)}</div>
                {o.catatan&&<div style={{ fontSize:11, background:"#FFFBEB", color:"#92400E", padding:"3px 7px", borderRadius:5, marginTop:4 }}>📝 {o.catatan}</div>}
                <div style={{ marginTop:6, display:"flex", gap:4, flexWrap:"wrap" }}>
                  {(o.tim||[]).map((m,i)=>{const tk=data.tukang.find(t=>t.id===m.id);return tk?<span key={i} style={{ background:"var(--color-background-secondary)", padding:"2px 7px", borderRadius:10, fontSize:10, color:"var(--color-text-secondary)" }}>{m.role==="Lead"?"⭐":"👤"} {tk.nama}</span>:null;})}
                </div>
              </div>
              <div style={{ textAlign:"right", minWidth:100 }}>
                <div style={{ fontSize:16, fontWeight:700, color:"#059669" }}>{rp(o.nilai)}</div>
                <div style={{ fontSize:10, color:o.bayar==="Lunas"?"#059669":"#DC2626", fontWeight:600, marginTop:2 }}>{o.bayar==="Lunas"?"✅ Lunas":"⏳ Belum"}</div>
                <div style={{ marginTop:7, display:"flex", flexDirection:"column", gap:4 }}>
                  <Btn label="Detail" variant="g" onClick={()=>setDetail(o)} style={{ fontSize:11, padding:"4px 9px" }} />
                  {o.status==="Terjadwal"&&<Btn label="▶ Mulai" variant="w" onClick={()=>setData(d=>({...d,order:d.order.map(ord=>ord.id===o.id?{...ord,status:"Berjalan"}:ord)}))} style={{ fontSize:11, padding:"4px 9px" }} />}
                  {o.status==="Berjalan"&&<Btn label="✅ Selesai" variant="s" onClick={()=>setData(d=>({...d,order:d.order.map(ord=>ord.id===o.id?{...ord,status:"Selesai"}:ord)}))} style={{ fontSize:11, padding:"4px 9px" }} />}
                </div>
              </div>
            </div>
          </Card>
        );
      })}
      {filtered.length===0&&<div style={{ textAlign:"center", padding:40, color:"var(--color-text-secondary)" }}>Tidak ada order</div>}

      {/* Modal Tambah Order */}
      <Modal open={modal} onClose={()=>setModal(false)} title="Order baru" width={560}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 10px" }}>
          <Inp label="Nama klien" value={form.klien} onChange={e=>setForm(f=>({...f,klien:e.target.value}))} />
          <Inp label="Tanggal" type="date" value={form.tgl} onChange={e=>setForm(f=>({...f,tgl:e.target.value}))} />
        </div>
        <Inp label="Alamat lokasi" value={form.alamat} onChange={e=>setForm(f=>({...f,alamat:e.target.value}))} />
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 10px" }}>
          <Sel label="Kompleksitas" value={form.komp} onChange={e=>setForm(f=>({...f,komp:e.target.value}))}>
            {Object.keys(KP).map(k=><option key={k}>{k}</option>)}
          </Sel>
          <Inp label="Kota" value={form.kota} onChange={e=>setForm(f=>({...f,kota:e.target.value}))} />
        </div>
        <Inp label="Item furniture" value={form.item} onChange={e=>setForm(f=>({...f,item:e.target.value}))} placeholder="Lemari 3 pintu, Kitchen Set..." />
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 10px" }}>
          <Inp label="Nilai jasa (Rp)" type="number" value={form.nilai} onChange={e=>setForm(f=>({...f,nilai:e.target.value}))} placeholder="500000" />
          <Sel label="Pembayaran" value={form.bayar} onChange={e=>setForm(f=>({...f,bayar:e.target.value}))}>
            <option>Belum</option><option>Lunas</option>
          </Sel>
        </div>
        <div style={{ marginBottom:10 }}>
          <label style={{ display:"block", fontSize:11, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:3 }}>Catatan</label>
          <textarea value={form.catatan} onChange={e=>setForm(f=>({...f,catatan:e.target.value}))} style={{ width:"100%", padding:"7px 10px", border:"1px solid var(--color-border-secondary)", borderRadius:7, fontSize:12, resize:"vertical", minHeight:50, background:"var(--color-background-primary)", color:"var(--color-text-primary)" }} />
        </div>

        {/* Rekomendasi tukang otomatis berdasarkan hari */}
        {hariOrder && rekomendasiTukang.length > 0 && (
          <div style={{ background:"#F0FDF4", border:"1px solid #86EFAC", borderRadius:9, padding:11, marginBottom:12 }}>
            <div style={{ fontSize:11, fontWeight:600, color:"#166534", marginBottom:7 }}>✅ Tukang tersedia hari {hariOrder} (klik untuk tambah ke tim):</div>
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              {rekomendasiTukang.map(t=>{
                const r=getRating(t.skor); const sudahDitambah=form.tim.some(m=>m.id===t.id);
                return (
                  <button key={t.id} onClick={()=>addRekomendasi(t)} disabled={sudahDitambah} style={{ padding:"5px 10px", borderRadius:16, border:`1.5px solid ${sudahDitambah?"#059669":"#86EFAC"}`, background:sudahDitambah?"#D1FAE5":"#fff", color:sudahDitambah?"#059669":"#374151", fontSize:11, fontWeight:600, cursor:sudahDitambah?"default":"pointer" }}>
                    {sudahDitambah?"✓ ":""}{t.nama} <span style={{ color:r.c }}>({t.level}, {t.skor})</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
        {hariOrder && rekomendasiTukang.length === 0 && (
          <div style={{ background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:9, padding:10, marginBottom:12, fontSize:11, color:"#DC2626" }}>
            ⚠️ Tidak ada tukang aktif tersedia pada hari {hariOrder}. Silakan atur jadwal tukang terlebih dahulu.
          </div>
        )}

        {/* Tim manual */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
          <label style={{ fontSize:11, fontWeight:600, color:"var(--color-text-secondary)" }}>Formasi tim</label>
          <button onClick={addTim} style={{ background:"#EFF6FF", color:"#1D4ED8", border:"none", borderRadius:6, padding:"3px 9px", fontSize:11, fontWeight:600, cursor:"pointer" }}>+ Tambah manual</button>
        </div>
        {form.tim.map((m,i)=>(
          <div key={i} style={{ display:"flex", gap:6, marginBottom:6 }}>
            <select value={m.id||""} onChange={e=>updTim(i,"id",e.target.value)} style={{ flex:2, padding:"6px 8px", border:"1px solid var(--color-border-secondary)", borderRadius:7, fontSize:11, background:"var(--color-background-primary)", color:"var(--color-text-primary)" }}>
              <option value="">Pilih tukang</option>
              {data.tukang.filter(t=>t.status==="Aktif").sort((a,b)=>b.skor-a.skor).map(t=><option key={t.id} value={t.id}>{t.nama} ({t.level},S:{t.skor})</option>)}
            </select>
            <select value={m.role} onChange={e=>updTim(i,"role",e.target.value)} style={{ flex:1, padding:"6px 8px", border:"1px solid var(--color-border-secondary)", borderRadius:7, fontSize:11, background:"var(--color-background-primary)", color:"var(--color-text-primary)" }}>
              <option>Lead</option><option>Anggota</option><option>Helper</option>
            </select>
            <button onClick={()=>remTim(i)} style={{ background:"#FEE2E2", color:"#DC2626", border:"none", borderRadius:6, padding:"6px 8px", cursor:"pointer" }}>✕</button>
          </div>
        ))}

        {/* Simulasi upah */}
        {sim.upah.length > 0 && (
          <div style={{ background:"#F0FDF4", border:"1px solid #86EFAC", borderRadius:8, padding:10, marginBottom:10 }}>
            <div style={{ fontSize:10, fontWeight:600, color:"#166534", marginBottom:5 }}>Simulasi ({(parseInt(form.nilai)||0)<200000?"80% tukang + 20% office":"75% tukang + 25% office"}):</div>
            <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, padding:"3px 0", borderBottom:"0.5px solid #86EFAC", marginBottom:3 }}><span>🏢 Office</span><b style={{ color:"#8B5CF6" }}>{rp(sim.office)}</b></div>
            {sim.upah.map((u,i)=><div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:11, padding:"2px 0", color:"var(--color-text-primary)" }}><span>{u.nama} ({u.role})</span><b>{u.pct}% = {rp(u.nom)}</b></div>)}
          </div>
        )}
        <div style={{ display:"flex", gap:8 }}>
          <Btn label="💾 Simpan order" onClick={save} style={{ flex:1 }} />
          <Btn label="Batal" variant="g" onClick={()=>setModal(false)} style={{ flex:1 }} />
        </div>
      </Modal>

      {/* Modal Detail Order */}
      <Modal open={!!detail} onClose={()=>setDetail(null)} title="Detail order" width={520}>
        {detail && (
          <div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:7, marginBottom:12 }}>
              {[["Klien",detail.klien],["Tanggal",fd(detail.tgl)+" ("+getDayName(detail.tgl)+")"],["Item",detail.item],["Kompleksitas",detail.komp],["Nilai jasa",rp(detail.nilai)],["Pembayaran",detail.bayar]].map(([k,v])=>(
                <div key={k} style={{ background:"var(--color-background-secondary)", borderRadius:7, padding:8 }}><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>{k}</div><div style={{ fontSize:12, fontWeight:500, color:"var(--color-text-primary)" }}>{v}</div></div>
              ))}
            </div>
            <div style={{ marginBottom:12 }}>
              <div style={{ fontSize:12, fontWeight:600, color:"var(--color-text-primary)", marginBottom:7 }}>Tim pengerjaan</div>
              {(detail.tim||[]).map((m,i)=>{const tk=data.tukang.find(t=>t.id===m.id);return tk?<div key={i} style={{ display:"flex", gap:7, padding:"5px 0", borderBottom:"0.5px solid var(--color-border-tertiary)", fontSize:12 }}><span>{m.role==="Lead"?"⭐":"👤"}</span><span style={{ fontWeight:500, color:"var(--color-text-primary)" }}>{tk.nama}</span><Badge label={m.role} color="#6B7280" bg="#F3F4F6" /><Badge label={tk.level} color={LV[tk.level].c} bg={LV[tk.level].bg} /></div>:null;})}
            </div>
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              {detail.status==="Terjadwal"&&<Btn label="▶ Mulai" variant="w" onClick={()=>{setData(d=>({...d,order:d.order.map(o=>o.id===detail.id?{...o,status:"Berjalan"}:o)}));setDetail(x=>({...x,status:"Berjalan"}));}} />}
              {detail.status==="Berjalan"&&<Btn label="✅ Selesai" variant="s" onClick={()=>{setData(d=>({...d,order:d.order.map(o=>o.id===detail.id?{...o,status:"Selesai"}:o)}));setDetail(x=>({...x,status:"Selesai"}));}} />}
              {detail.bayar!=="Lunas"&&<Btn label="💳 Lunas" onClick={()=>{setData(d=>({...d,order:d.order.map(o=>o.id===detail.id?{...o,bayar:"Lunas"}:o)}));setDetail(x=>({...x,bayar:"Lunas"}));}} />}
              <Btn label="Tutup" variant="g" onClick={()=>setDetail(null)} />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

// ─────────────────────────────────────────────
// JADWAL TUKANG (halaman dedicated)
// ─────────────────────────────────────────────
function JadwalTukang({ data, setData }) {
  const [cariHari, setCariHari] = useState("");

  const tukangAvailable = cariHari ? getTukangTersedia(data.tukang, cariHari) : [];
  const orderPadaHari = cariHari ? data.order.filter(o => getDayName(o.tgl) === cariHari) : [];

  return (
    <div>
      <div style={{ marginBottom:14 }}>
        <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Jadwal Ketersediaan Tukang</div>
        <div style={{ fontSize:12, color:"var(--color-text-secondary)" }}>Lihat siapa yang tersedia di hari tertentu</div>
      </div>

      {/* Grid mingguan */}
      <Card style={{ marginBottom:14 }}>
        <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:12 }}>📅 Jadwal Mingguan</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:6 }}>
          {HARI.map(h=>{
            const tersedia = data.tukang.filter(t=>t.status==="Aktif"&&(t.jadwal||[]).includes(h));
            const ada = tersedia.length > 0;
            return (
              <button key={h} onClick={()=>setCariHari(cariHari===h?"":h)} style={{ padding:"8px 4px", borderRadius:9, border:`1.5px solid ${cariHari===h?"#1D4ED8":ada?"#86EFAC":"var(--color-border-tertiary)"}`, background:cariHari===h?"#1D4ED8":ada?"#F0FDF4":"var(--color-background-secondary)", cursor:"pointer", transition:"all .15s" }}>
                <div style={{ fontSize:11, fontWeight:700, color:cariHari===h?"#fff":ada?"#166534":"var(--color-text-secondary)", marginBottom:5 }}>{h.substring(0,3)}</div>
                <div style={{ fontSize:18, fontWeight:800, color:cariHari===h?"#fff":ada?"#059669":"var(--color-text-secondary)" }}>{tersedia.length}</div>
                <div style={{ fontSize:9, color:cariHari===h?"#ffffffaa":ada?"#059669":"var(--color-text-secondary)" }}>tukang</div>
              </button>
            );
          })}
        </div>
      </Card>

      {/* Detail hari yang dipilih */}
      {cariHari && (
        <div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <div>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:10 }}>
                👷 Tukang tersedia hari {cariHari} ({tukangAvailable.length})
              </div>
              {tukangAvailable.length === 0
                ? <Card style={{ textAlign:"center", padding:24, color:"var(--color-text-secondary)", fontSize:12 }}>Tidak ada tukang tersedia</Card>
                : tukangAvailable.map(t=>{
                  const r=getRating(t.skor); const lv=LV[t.level];
                  return (
                    <Card key={t.id} style={{ marginBottom:9 }}>
                      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                        <div style={{ display:"flex", alignItems:"center", gap:9 }}>
                          <div style={{ width:36, height:36, borderRadius:"50%", background:lv.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:16 }}>👷</div>
                          <div>
                            <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>{t.nama}</div>
                            <div style={{ display:"flex", gap:5, marginTop:3 }}><Badge label={t.level} color={lv.c} bg={lv.bg} /><Badge label={r.l} color={r.c} bg={r.bg} /></div>
                          </div>
                        </div>
                        <div style={{ fontSize:22, fontWeight:800, color:r.c }}>{t.skor}</div>
                      </div>
                      <div style={{ fontSize:11, color:"var(--color-text-secondary)", marginTop:7 }}>📍 {t.kota} · 🏦 {t.rek||"-"}</div>
                      <div style={{ fontSize:11, color:"var(--color-text-secondary)", marginTop:2 }}>📦 {t.proyek} proyek · 💰 {rp(t.penghasilan)}</div>
                    </Card>
                  );
                })}
            </div>
            <div>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:10 }}>
                📦 Order di hari {cariHari} ({orderPadaHari.length})
              </div>
              {orderPadaHari.length === 0
                ? <Card style={{ textAlign:"center", padding:24, color:"var(--color-text-secondary)", fontSize:12 }}>Tidak ada order</Card>
                : orderPadaHari.map(o=>{
                  const sc=o.status==="Selesai"?"#059669":o.status==="Berjalan"?"#1D4ED8":"#D97706";
                  const sbg=o.status==="Selesai"?"#D1FAE5":o.status==="Berjalan"?"#DBEAFE":"#FEF3C7";
                  return (
                    <Card key={o.id} style={{ marginBottom:9 }}>
                      <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>{o.klien}</div>
                      <div style={{ fontSize:11, color:"var(--color-text-secondary)", margin:"3px 0" }}>{o.item}</div>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:6 }}>
                        <span style={{ fontSize:13, fontWeight:700, color:"#059669" }}>{rp(o.nilai)}</span>
                        <span style={{ padding:"2px 8px", borderRadius:10, fontSize:11, fontWeight:600, background:sbg, color:sc }}>{o.status}</span>
                      </div>
                      <div style={{ marginTop:6, display:"flex", gap:4, flexWrap:"wrap" }}>
                        {(o.tim||[]).map((m,i)=>{const tk=data.tukang.find(t=>t.id===m.id);return tk?<span key={i} style={{ background:"var(--color-background-secondary)", padding:"2px 7px", borderRadius:10, fontSize:10, color:"var(--color-text-secondary)" }}>{m.role==="Lead"?"⭐":"👤"} {tk.nama}</span>:null;})}
                      </div>
                    </Card>
                  );
                })}
            </div>
          </div>
          {/* Konflik/ketidaktersediaan */}
          {orderPadaHari.length > 0 && tukangAvailable.length > 0 && (() => {
            const tukangSibuk = new Set(orderPadaHari.flatMap(o=>(o.tim||[]).map(m=>m.id)));
            const konflik = tukangAvailable.filter(t=>tukangSibuk.has(t.id));
            if (!konflik.length) return null;
            return (
              <div style={{ background:"#FEF3C7", border:"1px solid #F59E0B30", borderRadius:9, padding:11, marginTop:12 }}>
                <div style={{ fontSize:11, fontWeight:600, color:"#92400E", marginBottom:5 }}>⚠️ Tukang sudah terjadwal di hari {cariHari}:</div>
                <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                  {konflik.map(t=><span key={t.id} style={{ background:"#FEF3C7", border:"1px solid #F59E0B", padding:"3px 9px", borderRadius:12, fontSize:11, color:"#92400E", fontWeight:600 }}>{t.nama}</span>)}
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {/* Tabel ringkasan semua tukang */}
      <Card style={{ marginTop:14 }}>
        <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:12 }}>Ringkasan jadwal semua tukang</div>
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
            <thead>
              <tr style={{ borderBottom:"1px solid var(--color-border-secondary)" }}>
                <th style={{ padding:"7px 10px", textAlign:"left", fontWeight:600, color:"var(--color-text-secondary)" }}>Tukang</th>
                <th style={{ padding:"7px 10px", textAlign:"left", fontWeight:600, color:"var(--color-text-secondary)" }}>Level</th>
                {HARI.map(h=><th key={h} style={{ padding:"7px 6px", textAlign:"center", fontWeight:600, color:"var(--color-text-secondary)", minWidth:40 }}>{h.substring(0,3)}</th>)}
              </tr>
            </thead>
            <tbody>
              {data.tukang.map(t=>(
                <tr key={t.id} style={{ borderBottom:"0.5px solid var(--color-border-tertiary)" }}>
                  <td style={{ padding:"8px 10px", fontWeight:500, color:"var(--color-text-primary)" }}>{t.nama}</td>
                  <td style={{ padding:"8px 10px" }}><Badge label={t.level} color={LV[t.level].c} bg={LV[t.level].bg} /></td>
                  {HARI.map(h=>{
                    const avail=(t.jadwal||[]).includes(h);
                    return <td key={h} style={{ padding:"8px 6px", textAlign:"center" }}>
                      <span style={{ fontSize:14 }}>{avail?"✅":"—"}</span>
                    </td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}

// ─────────────────────────────────────────────
// KEUANGAN
// ─────────────────────────────────────────────
function Keuangan({ data, setData }) {
  const [modal, setModal] = useState(false);
  const [sel, setSel] = useState(""); const [tmb, setTmb] = useState(0);

  const pending = data.order.filter(o=>o.status==="Selesai"&&!data.keuangan.find(k=>k.order_id===o.id));
  const totalOmset = data.keuangan.reduce((s,k)=>s+k.total,0);
  const totalOffice = data.keuangan.reduce((s,k)=>s+(k.office||0),0);
  const totalTukang = data.keuangan.reduce((s,k)=>s+(k.tukang_total||0),0);

  const selO = sel ? data.order.find(o=>o.id===parseInt(sel)) : null;
  const sim = selO ? hitungUpah((selO.nilai||0)+parseInt(tmb||0), selO.tim, data.tukang) : { upah:[], office:0, tukang_total:0 };

  const proses = () => {
    if (!sel) { alert("Pilih order"); return; }
    const o = data.order.find(ord=>ord.id===parseInt(sel));
    const nilaiTotal = (o.nilai||0)+parseInt(tmb||0);
    const h = hitungUpah(nilaiTotal, o.tim, data.tukang);
    setData(d=>({
      ...d,
      keuangan:[...d.keuangan,{id:Date.now(),order_id:o.id,tgl:new Date().toISOString().split("T")[0],total:nilaiTotal,office:h.office,tukang_total:h.tukang_total,status:"Pending",upah:h.upah}],
      tukang:d.tukang.map(t=>{const u=h.upah.find(u=>u.tid===t.id);return u?{...t,penghasilan:t.penghasilan+u.nom,proyek:t.proyek+1}:t;})
    }));
    setModal(false); setSel(""); setTmb(0);
  };

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Keuangan & komisi</div>
        {pending.length>0&&<Btn label="+ Proses upah" onClick={()=>setModal(true)} />}
      </div>
      <div style={{ background:"#F5F3FF", borderRadius:10, padding:12, marginBottom:14, border:"1px solid #DDD6FE" }}>
        <div style={{ fontSize:11, fontWeight:600, color:"#6D28D9", marginBottom:8 }}>Formula Pembagian Aktif</div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
          <div style={{ background:"#fff", borderRadius:7, padding:8, borderLeft:"3px solid #3B82F6" }}><div style={{ fontSize:10, color:"#3B82F6", fontWeight:600 }}>Order &lt; Rp 200.000</div><div style={{ fontSize:12, color:"var(--color-text-primary)", marginTop:3 }}>Office <b>20%</b> · Tukang <b>80%</b></div></div>
          <div style={{ background:"#fff", borderRadius:7, padding:8, borderLeft:"3px solid #8B5CF6" }}><div style={{ fontSize:10, color:"#8B5CF6", fontWeight:600 }}>Order ≥ Rp 200.000</div><div style={{ fontSize:12, color:"var(--color-text-primary)", marginTop:3 }}>Office <b>25%</b> · Tukang <b>75%</b></div></div>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:14 }}>
        <StatCard icon="💼" label="Total omset" value={rp(totalOmset)} color="#1D4ED8" />
        <StatCard icon="🏢" label="Bagian office" value={rp(totalOffice)} color="#8B5CF6" />
        <StatCard icon="👷" label="Bagian tukang" value={rp(totalTukang)} color="#059669" />
      </div>
      {data.keuangan.length===0&&<Card style={{ textAlign:"center", padding:36 }}><div style={{ fontSize:32, marginBottom:8 }}>💰</div><div style={{ color:"var(--color-text-secondary)" }}>Proses order selesai terlebih dahulu.</div></Card>}
      {[...data.keuangan].reverse().map(k=>{
        const o=data.order.find(ord=>ord.id===k.order_id);
        const po=k.total<200000?20:25; const pt=k.total<200000?80:75;
        return (
          <Card key={k.id} style={{ marginBottom:10 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
              <div><div style={{ fontSize:14, fontWeight:600, color:"var(--color-text-primary)" }}>{o?.klien||"—"}</div><div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>📅 {fd(k.tgl)} · {o?.item||""}</div></div>
              <div style={{ textAlign:"right" }}><div style={{ fontSize:18, fontWeight:700, color:"#059669" }}>{rp(k.total)}</div><span style={{ fontSize:11, padding:"2px 8px", borderRadius:12, background:k.status==="Cair"?"#D1FAE5":"#FEF3C7", color:k.status==="Cair"?"#059669":"#D97706" }}>{k.status}</span></div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:7, marginBottom:10 }}>
              <div style={{ background:"#F5F3FF", borderRadius:8, padding:9, borderLeft:"3px solid #8B5CF6" }}><div style={{ fontSize:10, color:"#8B5CF6", fontWeight:600 }}>Office ({po}%)</div><div style={{ fontSize:16, fontWeight:700, color:"#8B5CF6" }}>{rp(k.office||0)}</div></div>
              <div style={{ background:"#F0FDF4", borderRadius:8, padding:9, borderLeft:"3px solid #059669" }}><div style={{ fontSize:10, color:"#059669", fontWeight:600 }}>Tukang ({pt}%)</div><div style={{ fontSize:16, fontWeight:700, color:"#059669" }}>{rp(k.tukang_total||0)}</div></div>
            </div>
            <div style={{ background:"var(--color-background-secondary)", borderRadius:9, padding:10, marginBottom:9 }}>
              <div style={{ fontSize:10, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:6 }}>Rincian per tukang:</div>
              {k.upah.map((u,i)=>{
                const tk=data.tukang.find(t=>t.id===u.tid);
                return <div key={i} style={{ display:"flex", justifyContent:"space-between", padding:"4px 0", borderBottom:i<k.upah.length-1?"0.5px solid var(--color-border-tertiary)":"" }}>
                  <div><span style={{ fontSize:12, fontWeight:500, color:"var(--color-text-primary)" }}>{u.nama}</span><span style={{ fontSize:10, color:"var(--color-text-secondary)", marginLeft:6 }}>{u.role} · {u.pct}%</span>{tk&&<div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>🏦 {tk.rek}</div>}</div>
                  <div style={{ fontSize:13, fontWeight:600, color:"#1D4ED8" }}>{rp(u.nom)}</div>
                </div>;
              })}
            </div>
            {k.status==="Pending"
              ? <Btn label="💸 Cairkan via transfer bank" variant="s" onClick={()=>setData(d=>({...d,keuangan:d.keuangan.map(kk=>kk.id===k.id?{...kk,status:"Cair",cair_tgl:new Date().toISOString().split("T")[0]}:kk)}))} />
              : <div style={{ fontSize:11, color:"#059669" }}>✅ Dicairkan {fd(k.cair_tgl)}</div>}
          </Card>
        );
      })}
      <Modal open={modal} onClose={()=>setModal(false)} title="Proses pembagian upah">
        <Sel label="Pilih order selesai" value={sel} onChange={e=>setSel(e.target.value)}>
          <option value="">-- Pilih order --</option>
          {pending.map(o=><option key={o.id} value={o.id}>{o.klien} — {o.item} ({rp(o.nilai)})</option>)}
        </Sel>
        <Inp label="Biaya tambahan (Rp)" type="number" value={tmb} onChange={e=>setTmb(e.target.value)} placeholder="0" />
        {sim.upah.length>0&&(
          <div style={{ background:"#F0FDF4", border:"1px solid #86EFAC", borderRadius:8, padding:10, marginBottom:10 }}>
            <div style={{ fontSize:10, fontWeight:600, color:"#166534", marginBottom:5 }}>Formula: {((selO?.nilai||0)+parseInt(tmb||0))<200000?"80% tukang + 20% office":"75% tukang + 25% office"}</div>
            <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, padding:"4px 0", borderBottom:"1px solid #86EFAC", marginBottom:4 }}><span>🏢 Bagian office</span><b style={{ color:"#8B5CF6" }}>{rp(sim.office)}</b></div>
            {sim.upah.map((u,i)=><div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:12, padding:"2px 0", color:"var(--color-text-primary)" }}><span>{u.nama} ({u.role})</span><b>{rp(u.nom)}</b></div>)}
          </div>
        )}
        {sel&&sim.upah.length===0&&<div style={{ color:"#DC2626", fontSize:12, marginBottom:10 }}>Tim belum diisi pada order ini</div>}
        <div style={{ display:"flex", gap:8 }}>
          <Btn label="💾 Proses" onClick={proses} disabled={!sel} style={{ flex:1 }} />
          <Btn label="Batal" variant="g" onClick={()=>setModal(false)} style={{ flex:1 }} />
        </div>
      </Modal>
    </div>
  );
}

// ─────────────────────────────────────────────
// KLIEN
// ─────────────────────────────────────────────
function Klien({ data, setData }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ nama:"", tel:"", alamat:"", email:"", kota:"Yogyakarta" });
  const save = () => {
    if (!form.nama||!form.tel) { alert("Nama dan telepon wajib"); return; }
    setData(d=>({...d, klien:[...d.klien,{...form,id:Date.now()}]}));
    setModal(false); setForm({ nama:"", tel:"", alamat:"", email:"", kota:"Yogyakarta" });
  };
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Data klien</div>
        <Btn label="+ Tambah klien" onClick={()=>setModal(true)} />
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:11 }}>
        {data.klien.map(k=>{
          const ok=data.order.filter(o=>o.klien===k.nama);
          return (
            <Card key={k.id}>
              <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:11 }}>
                <div style={{ width:38, height:38, borderRadius:"50%", background:"#EFF6FF", display:"flex", alignItems:"center", justifyContent:"center", fontSize:17 }}>🏢</div>
                <div><div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>{k.nama}</div><div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>📍 {k.kota}</div></div>
              </div>
              <div style={{ fontSize:11, color:"var(--color-text-secondary)", display:"flex", flexDirection:"column", gap:3, marginBottom:11 }}>
                <span>📱 {k.tel}</span>{k.email&&<span>📧 {k.email}</span>}<span>🏠 {k.alamat}</span>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:7, marginBottom:10 }}>
                <div style={{ background:"#F0FDF4", borderRadius:8, padding:8, textAlign:"center" }}><div style={{ fontSize:18, fontWeight:700, color:"#059669" }}>{ok.length}</div><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>Order</div></div>
                <div style={{ background:"#EFF6FF", borderRadius:8, padding:8, textAlign:"center" }}><div style={{ fontSize:11, fontWeight:700, color:"#1D4ED8" }}>{rp(ok.reduce((s,o)=>s+o.nilai,0))}</div><div style={{ fontSize:10, color:"var(--color-text-secondary)" }}>Total nilai</div></div>
              </div>
              <a href={`https://wa.me/${k.tel.replace(/^0/,"62")}`} target="_blank" rel="noreferrer" style={{ display:"block", textAlign:"center", padding:"6px", background:"#25D366", color:"#fff", borderRadius:7, fontSize:12, fontWeight:600, textDecoration:"none" }}>💬 WhatsApp</a>
            </Card>
          );
        })}
      </div>
      <Modal open={modal} onClose={()=>setModal(false)} title="Tambah klien">
        <Inp label="Nama / Perusahaan" value={form.nama} onChange={e=>setForm(f=>({...f,nama:e.target.value}))} />
        <Inp label="Telepon" value={form.tel} onChange={e=>setForm(f=>({...f,tel:e.target.value}))} placeholder="08xxx" />
        <Inp label="Email" type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} />
        <Inp label="Alamat" value={form.alamat} onChange={e=>setForm(f=>({...f,alamat:e.target.value}))} />
        <Inp label="Kota" value={form.kota} onChange={e=>setForm(f=>({...f,kota:e.target.value}))} />
        <div style={{ display:"flex", gap:8 }}>
          <Btn label="💾 Simpan" onClick={save} style={{ flex:1 }} />
          <Btn label="Batal" variant="g" onClick={()=>setModal(false)} style={{ flex:1 }} />
        </div>
      </Modal>
    </div>
  );
}

// ─────────────────────────────────────────────
// SOP CHECKLIST
// ─────────────────────────────────────────────
function SOPChecklist({ data }) {
  const [selOrder, setSelOrder] = useState(null);
  const [chk, setChk] = useState({});
  const toggle = (sec,i) => { const k=`${selOrder}_${sec}_${i}`; setChk(c=>({...c,[k]:!c[k]})); };
  const getProg = sec => { const items=SOP_ITEMS[sec]; const done=items.filter((_,i)=>chk[`${selOrder}_${sec}_${i}`]).length; return {done,total:items.length,pct:Math.round(done/items.length*100)}; };
  const secs = [{k:"persiapan",icon:"🚀",title:"SOP 1: Persiapan"},{k:"checkin",icon:"📍",title:"SOP 2: Check-in"},{k:"eksekusi",icon:"🔧",title:"SOP 3: Eksekusi"},{k:"serahterima",icon:"✅",title:"SOP 5: Serah terima"}];
  const berjalan = data.order.filter(o=>o.status==="Berjalan"||o.status==="Terjadwal");

  if (!selOrder) return (
    <div>
      <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)", marginBottom:14 }}>SOP Checklist</div>
      <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginBottom:12 }}>Pilih order aktif:</div>
      {berjalan.length===0&&<Card style={{ textAlign:"center", padding:36, color:"var(--color-text-secondary)" }}>Tidak ada order berjalan</Card>}
      {berjalan.map(o=>(
        <Card key={o.id} onClick={()=>setSelOrder(o.id)} style={{ marginBottom:9, cursor:"pointer" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div><div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>{o.klien}</div><div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>{o.item} · {fd(o.tgl)}</div></div>
            <span style={{ fontSize:24 }}>📋</span>
          </div>
        </Card>
      ))}
    </div>
  );

  const o = data.order.find(ord=>ord.id===selOrder);
  return (
    <div>
      <button onClick={()=>setSelOrder(null)} style={{ background:"var(--color-background-secondary)", border:"none", borderRadius:7, padding:"6px 12px", fontSize:12, fontWeight:500, marginBottom:12, cursor:"pointer", color:"var(--color-text-primary)" }}>← Kembali</button>
      <div style={{ background:"#1D4ED8", borderRadius:12, padding:14, marginBottom:14, color:"#fff" }}>
        <div style={{ fontWeight:600, fontSize:15 }}>{o?.klien}</div>
        <div style={{ fontSize:11, opacity:.8 }}>{o?.item} · {o?.alamat}</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:6, marginTop:10 }}>
          {secs.map(s=>{const p=getProg(s.k);return <div key={s.k} style={{ background:"#ffffff22", borderRadius:7, padding:7, textAlign:"center" }}><div style={{ fontSize:16, fontWeight:700 }}>{p.pct}%</div><div style={{ fontSize:9, opacity:.8 }}>{s.k}</div></div>;})}
        </div>
      </div>
      {secs.map(({k,icon,title})=>{
        const p=getProg(k);
        return (
          <Card key={k} style={{ marginBottom:11 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:9 }}>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>{icon} {title}</div>
              <span style={{ fontSize:12, fontWeight:600, color:p.pct===100?"#059669":"var(--color-text-secondary)" }}>{p.done}/{p.total}</span>
            </div>
            <div style={{ height:4, background:"var(--color-background-secondary)", borderRadius:8, marginBottom:10 }}>
              <div style={{ height:"100%", width:`${p.pct}%`, background:p.pct===100?"#059669":"#1D4ED8", borderRadius:8, transition:"width .3s" }} />
            </div>
            {SOP_ITEMS[k].map((item,i)=>{
              const checked=chk[`${selOrder}_${k}_${i}`];
              return <div key={i} onClick={()=>toggle(k,i)} style={{ display:"flex", gap:9, alignItems:"flex-start", padding:"6px 0", cursor:"pointer", borderBottom:i<SOP_ITEMS[k].length-1?"0.5px solid var(--color-border-tertiary)":"" }}>
                <div style={{ width:18, height:18, borderRadius:4, border:`1.5px solid ${checked?"#059669":"var(--color-border-secondary)"}`, background:checked?"#059669":"var(--color-background-primary)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>{checked&&<span style={{ color:"#fff", fontSize:11 }}>✓</span>}</div>
                <span style={{ fontSize:12, color:checked?"var(--color-text-secondary)":"var(--color-text-primary)", textDecoration:checked?"line-through":"none" }}>{item}</span>
              </div>;
            })}
          </Card>
        );
      })}
    </div>
  );
}

// ─────────────────────────────────────────────
// PEMBUKUAN
// ─────────────────────────────────────────────
function Pembukuan({ data, setData }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ tgl:"", jenis:"pemasukan", kategori:"", keterangan:"", jumlah:"", pihak:"" });
  const [filter, setFilter] = useState("semua");

  const save = () => {
    if (!form.keterangan||!form.jumlah) { alert("Keterangan dan jumlah wajib"); return; }
    setData(d=>({...d,pembukuan:[...d.pembukuan,{...form,id:Date.now(),jumlah:parseInt(form.jumlah),status:(form.jenis==="pemasukan"||form.jenis==="pengeluaran")?"Lunas":"Belum Lunas"}]}));
    setModal(false); setForm({ tgl:new Date().toISOString().split("T")[0], jenis:"pemasukan", kategori:"", keterangan:"", jumlah:"", pihak:"" });
  };
  const lunasPb = id => setData(d=>({...d,pembukuan:d.pembukuan.map(p=>p.id===id?{...p,status:"Lunas"}:p)}));

  const totalMasuk  = data.pembukuan.filter(p=>p.jenis==="pemasukan").reduce((s,p)=>s+p.jumlah,0);
  const totalKeluar = data.pembukuan.filter(p=>p.jenis==="pengeluaran").reduce((s,p)=>s+p.jumlah,0);
  const totalPiutang= data.pembukuan.filter(p=>p.jenis==="piutang"&&p.status==="Belum Lunas").reduce((s,p)=>s+p.jumlah,0);
  const totalHutang = data.pembukuan.filter(p=>p.jenis==="hutang"&&p.status==="Belum Lunas").reduce((s,p)=>s+p.jumlah,0);
  const saldo = totalMasuk - totalKeluar;

  const JS = { pemasukan:{c:"#059669",bg:"#D1FAE5",icon:"📥"}, pengeluaran:{c:"#DC2626",bg:"#FEE2E2",icon:"📤"}, piutang:{c:"#1D4ED8",bg:"#DBEAFE",icon:"💳"}, hutang:{c:"#D97706",bg:"#FEF3C7",icon:"🔴"} };
  const filtered = filter==="semua" ? data.pembukuan : data.pembukuan.filter(p=>p.jenis===filter);

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Pembukuan</div>
        <Btn label="+ Catat transaksi" onClick={()=>{setForm({tgl:new Date().toISOString().split("T")[0],jenis:"pemasukan",kategori:"",keterangan:"",jumlah:"",pihak:""});setModal(true);}} />
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:14 }}>
        <StatCard icon="📥" label="Total pemasukan"        value={rp(totalMasuk)}   color="#059669" />
        <StatCard icon="📤" label="Total pengeluaran"       value={rp(totalKeluar)}  color="#DC2626" />
        <StatCard icon="💳" label="Piutang belum lunas"     value={rp(totalPiutang)} color="#1D4ED8" />
        <StatCard icon="🔴" label="Hutang belum lunas"      value={rp(totalHutang)}  color="#D97706" />
      </div>
      <Card style={{ marginBottom:14, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div><div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>Saldo bersih</div><div style={{ fontSize:22, fontWeight:700, color:saldo>=0?"#059669":"#DC2626" }}>{rp(Math.abs(saldo))}{saldo<0?" (defisit)":""}</div></div>
        <span style={{ fontSize:32 }}>{saldo>=0?"📈":"📉"}</span>
      </Card>
      <div style={{ display:"flex", gap:6, marginBottom:12, flexWrap:"wrap" }}>
        {["semua","pemasukan","pengeluaran","piutang","hutang"].map(j=>{
          const st=j!=="semua"?JS[j]:null; const active=filter===j;
          return <button key={j} onClick={()=>setFilter(j)} style={{ padding:"5px 12px", borderRadius:16, border:"1px solid", borderColor:active?(st?.c||"#1D4ED8"):"var(--color-border-tertiary)", background:active?(st?.bg||"#EFF6FF"):"var(--color-background-primary)", color:active?(st?.c||"#1D4ED8"):"var(--color-text-primary)", fontSize:12, fontWeight:active?600:400, cursor:"pointer", textTransform:"capitalize" }}>{j==="semua"?"Semua":j}</button>;
        })}
      </div>
      {filtered.length===0&&<Card style={{ textAlign:"center", padding:30, color:"var(--color-text-secondary)" }}>Tidak ada catatan</Card>}
      {[...filtered].reverse().map(p=>{
        const st=JS[p.jenis]||{c:"#6B7280",bg:"#F3F4F6",icon:"📝"}; const isDebt=p.jenis==="hutang"||p.jenis==="piutang";
        return (
          <Card key={p.id} style={{ marginBottom:9 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div style={{ display:"flex", gap:10, alignItems:"flex-start", flex:1 }}>
                <div style={{ width:36, height:36, borderRadius:8, background:st.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, flexShrink:0 }}>{st.icon}</div>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap", marginBottom:3 }}>
                    <span style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>{p.keterangan}</span>
                    <span style={{ background:st.bg, color:st.c, padding:"1px 7px", borderRadius:10, fontSize:10, fontWeight:600, textTransform:"capitalize" }}>{p.jenis}</span>
                    {isDebt&&<span style={{ padding:"1px 7px", borderRadius:10, fontSize:10, fontWeight:600, background:p.status==="Lunas"?"#D1FAE5":"#FEF3C7", color:p.status==="Lunas"?"#059669":"#D97706" }}>{p.status}</span>}
                  </div>
                  <div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>{p.kategori}{p.pihak?" · "+p.pihak:""} · 📅 {fd(p.tgl)}</div>
                </div>
              </div>
              <div style={{ textAlign:"right", minWidth:100 }}>
                <div style={{ fontSize:15, fontWeight:700, color:st.c }}>{p.jenis==="pemasukan"?"+":"-"}{rp(p.jumlah)}</div>
                {isDebt&&p.status==="Belum Lunas"&&<Btn label="Tandai lunas" variant="s" onClick={()=>lunasPb(p.id)} style={{ fontSize:10, padding:"4px 8px", marginTop:5 }} />}
              </div>
            </div>
          </Card>
        );
      })}
      <Modal open={modal} onClose={()=>setModal(false)} title="Catat transaksi">
        <Sel label="Jenis" value={form.jenis} onChange={e=>setForm(f=>({...f,jenis:e.target.value}))}>
          <option value="pemasukan">📥 Pemasukan</option>
          <option value="pengeluaran">📤 Pengeluaran</option>
          <option value="piutang">💳 Piutang</option>
          <option value="hutang">🔴 Hutang</option>
        </Sel>
        <Inp label="Tanggal" type="date" value={form.tgl} onChange={e=>setForm(f=>({...f,tgl:e.target.value}))} />
        <Inp label="Keterangan" value={form.keterangan} onChange={e=>setForm(f=>({...f,keterangan:e.target.value}))} placeholder="Deskripsi transaksi" />
        <Inp label="Kategori" value={form.kategori} onChange={e=>setForm(f=>({...f,kategori:e.target.value}))} placeholder="Operasional, Jasa Rakit, Supplier..." />
        <Inp label="Jumlah (Rp)" type="number" value={form.jumlah} onChange={e=>setForm(f=>({...f,jumlah:e.target.value}))} placeholder="0" />
        {(form.jenis==="hutang"||form.jenis==="piutang")&&<Inp label="Nama pihak" value={form.pihak} onChange={e=>setForm(f=>({...f,pihak:e.target.value}))} placeholder="Nama klien / kreditur" />}
        <div style={{ display:"flex", gap:8, marginTop:6 }}>
          <Btn label="💾 Simpan" onClick={save} style={{ flex:1 }} />
          <Btn label="Batal" variant="g" onClick={()=>setModal(false)} style={{ flex:1 }} />
        </div>
      </Modal>
    </div>
  );
}

// ─────────────────────────────────────────────
// LAPORAN
// ─────────────────────────────────────────────
function Laporan({ data }) {
  const [tab, setTab] = useState("rekap");
  const [waToken, setWaToken] = useState(""); const [waNum, setWaNum] = useState(""); const [waStatus, setWaStatus] = useState("");
  const [sheetsUrl, setSheetsUrl] = useState("");

  const now = new Date(); const bln=now.getMonth(); const thn=now.getFullYear();
  const obl = data.order.filter(o=>{const d=new Date(o.tgl);return d.getMonth()===bln&&d.getFullYear()===thn;});
  const omset = obl.filter(o=>o.status==="Selesai").reduce((s,o)=>s+o.nilai,0);
  const officeTotal = data.keuangan.reduce((s,k)=>s+(k.office||0),0);
  const upahTotal = data.keuangan.reduce((s,k)=>s+k.upah.reduce((ss,u)=>ss+u.nom,0),0);
  const pengeluaran = data.pembukuan.filter(p=>p.jenis==="pengeluaran").reduce((s,p)=>s+p.jumlah,0);

  const rekap = `*📊 REKAP HARIAN RAKITIN.PRO*\n📅 ${now.toLocaleDateString("id-ID")}\n\n💰 Omset: ${rp(omset)}\n🏢 Pendapatan office: ${rp(officeTotal)}\n📤 Pengeluaran: ${rp(pengeluaran)}\n📈 Laba bersih: ${rp(officeTotal-pengeluaran)}\n👷 Upah tukang: ${rp(upahTotal)}\n📦 Order bulan ini: ${obl.length}\n⭐ Tukang Gold: ${data.tukang.filter(t=>t.skor>=90).length}\n\n_Rakitin.pro — Rakit Lebih Baik_`;

  const kirimWA = async () => {
    if (!waToken||!waNum) { setWaStatus("error:Isi token dan nomor"); return; }
    setWaStatus("loading");
    try {
      const r = await fetch("https://api.fonnte.com/send",{method:"POST",headers:{"Authorization":waToken,"Content-Type":"application/json"},body:JSON.stringify({target:waNum,message:rekap})});
      const d = await r.json();
      setWaStatus(d.status?"ok":"error:"+(d.reason||"Gagal"));
    } catch { setWaStatus("error:Error koneksi"); }
  };

  const exportCSV = () => {
    const rows=[["ID","Klien","Item","Tanggal","Hari","Kompleksitas","Nilai","Status","Pembayaran"],...data.order.map(o=>[o.id,o.klien,o.item,o.tgl,getDayName(o.tgl),o.komp,o.nilai,o.status,o.bayar])];
    const b=new Blob([rows.map(r=>r.join(",")).join("\n")],{type:"text/csv"});
    const a=document.createElement("a");a.href=URL.createObjectURL(b);a.download="laporan-rakitin.csv";a.click();
  };

  const tabs = [["rekap","📊 Rekap"],["pengeluaran","📤 Pengeluaran"],["wa","💬 WhatsApp"],["sheets","📗 Google Sheets"]];

  return (
    <div>
      <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)", marginBottom:14 }}>Laporan & integrasi</div>
      <div style={{ display:"flex", gap:6, marginBottom:14, flexWrap:"wrap" }}>
        {tabs.map(([k,l])=><button key={k} onClick={()=>setTab(k)} style={{ padding:"6px 13px", borderRadius:8, border:"1px solid", borderColor:tab===k?"#1D4ED8":"var(--color-border-tertiary)", background:tab===k?"#EFF6FF":"var(--color-background-primary)", color:tab===k?"#1D4ED8":"var(--color-text-primary)", fontSize:12, fontWeight:tab===k?600:400, cursor:"pointer" }}>{l}</button>)}
      </div>

      {tab==="rekap"&&(
        <div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:14 }}>
            <StatCard icon="📦" label="Order bulan ini"    value={obl.length}                color="#1D4ED8" />
            <StatCard icon="💰" label="Omset bulan ini"    value={rp(omset)}                 color="#059669" />
            <StatCard icon="🏢" label="Pendapatan office"  value={rp(officeTotal)}           color="#8B5CF6" />
            <StatCard icon="👷" label="Upah tukang"        value={rp(upahTotal)}             color="#059669" />
            <StatCard icon="📤" label="Total pengeluaran"  value={rp(pengeluaran)}           color="#DC2626" />
            <StatCard icon="📈" label="Laba bersih"        value={rp(officeTotal-pengeluaran)} color="#059669" />
          </div>
          <Card>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:11 }}>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)" }}>Performa tukang</div>
              <Btn label="⬇ Export CSV" variant="g" onClick={exportCSV} style={{ fontSize:11 }} />
            </div>
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
                <thead><tr>{["Tukang","Level","Skor","Rating","Proyek","Penghasilan"].map(h=><th key={h} style={{ padding:"6px 8px", textAlign:"left", fontWeight:600, color:"var(--color-text-secondary)", borderBottom:"1px solid var(--color-border-secondary)" }}>{h}</th>)}</tr></thead>
                <tbody>{[...data.tukang].sort((a,b)=>b.skor-a.skor).map(t=>{const r=getRating(t.skor);return<tr key={t.id} style={{ borderBottom:"0.5px solid var(--color-border-tertiary)" }}><td style={{ padding:"7px 8px", fontWeight:500, color:"var(--color-text-primary)" }}>{t.nama}</td><td style={{ padding:"7px 8px" }}><Badge label={t.level} color={LV[t.level].c} bg={LV[t.level].bg} /></td><td style={{ padding:"7px 8px", fontWeight:700, color:r.c }}>{t.skor}</td><td style={{ padding:"7px 8px" }}><Badge label={r.l} color={r.c} bg={r.bg} /></td><td style={{ padding:"7px 8px", color:"var(--color-text-primary)" }}>{t.proyek}</td><td style={{ padding:"7px 8px", fontWeight:600, color:"var(--color-text-primary)" }}>{rp(t.penghasilan)}</td></tr>;})}</tbody>
              </table>
            </div>
          </Card>
        </div>
      )}

      {tab==="pengeluaran"&&(()=>{
        const pgl=data.pembukuan.filter(p=>p.jenis==="pengeluaran");
        const byKat={}; pgl.forEach(p=>{byKat[p.kategori]=(byKat[p.kategori]||0)+p.jumlah;});
        return (
          <div>
            <StatCard icon="📤" label="Total pengeluaran" value={rp(pgl.reduce((s,p)=>s+p.jumlah,0))} color="#DC2626" />
            <Card style={{ marginTop:12, marginBottom:12 }}>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:10 }}>Per kategori</div>
              {Object.entries(byKat).map(([k,v])=><div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", borderBottom:"0.5px solid var(--color-border-tertiary)" }}><span style={{ fontSize:13, color:"var(--color-text-primary)" }}>📤 {k}</span><span style={{ fontSize:13, fontWeight:600, color:"#DC2626" }}>{rp(v)}</span></div>)}
              {Object.keys(byKat).length===0&&<div style={{ color:"var(--color-text-secondary)", fontSize:12 }}>Belum ada pengeluaran</div>}
            </Card>
            <Card>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:10 }}>Rincian</div>
              {[...pgl].reverse().map(p=><div key={p.id} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0", borderBottom:"0.5px solid var(--color-border-tertiary)" }}><div><div style={{ fontSize:12, fontWeight:500, color:"var(--color-text-primary)" }}>{p.keterangan}</div><div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>{p.kategori} · {fd(p.tgl)}</div></div><div style={{ fontSize:13, fontWeight:600, color:"#DC2626" }}>-{rp(p.jumlah)}</div></div>)}
            </Card>
          </div>
        );
      })()}

      {tab==="wa"&&(
        <Card>
          <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:12 }}>Notifikasi WhatsApp via Fonnte</div>
          <div style={{ background:"#FEF3C7", borderRadius:8, padding:10, marginBottom:12, fontSize:12, color:"#92400E" }}>Daftar di <a href="https://fonnte.com" target="_blank" rel="noreferrer" style={{ color:"#1D4ED8" }}>fonnte.com</a> untuk token API WA Business Anda.</div>
          <Inp label="Token API Fonnte" type="password" value={waToken} onChange={e=>setWaToken(e.target.value)} placeholder="Token dari dashboard fonnte.com" />
          <Inp label="Nomor admin (628xxx)" value={waNum} onChange={e=>setWaNum(e.target.value)} placeholder="6281234567890" />
          <div style={{ background:"var(--color-background-secondary)", borderRadius:8, padding:10, marginBottom:12 }}>
            <div style={{ fontSize:11, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:5 }}>Preview:</div>
            <pre style={{ fontSize:11, whiteSpace:"pre-wrap", fontFamily:"monospace", color:"var(--color-text-primary)" }}>{rekap}</pre>
          </div>
          {waStatus==="loading"&&<div style={{ padding:8, borderRadius:7, background:"#DBEAFE", color:"#1D4ED8", fontSize:12, marginBottom:8 }}>Mengirim...</div>}
          {waStatus==="ok"&&<div style={{ padding:8, borderRadius:7, background:"#D1FAE5", color:"#059669", fontSize:12, marginBottom:8 }}>✅ Berhasil dikirim!</div>}
          {waStatus.startsWith("error:")&&<div style={{ padding:8, borderRadius:7, background:"#FEE2E2", color:"#DC2626", fontSize:12, marginBottom:8 }}>❌ {waStatus.replace("error:","")}</div>}
          <Btn label="📤 Kirim rekap ke WhatsApp" variant="s" onClick={kirimWA} style={{ width:"100%" }} />
        </Card>
      )}

      {tab==="sheets"&&(
        <Card>
          <div style={{ fontSize:13, fontWeight:600, color:"var(--color-text-primary)", marginBottom:12 }}>Google Sheets Integration</div>
          <div style={{ background:"#EFF6FF", borderRadius:8, padding:10, marginBottom:12, fontSize:12, color:"#1D4ED8" }}>
            <b>Cara setup:</b><ol style={{ margin:"6px 0 0", paddingLeft:16, lineHeight:1.9 }}><li>Google Sheets → Extensions → Apps Script</li><li>Paste kode dari file google-apps-script.js</li><li>Deploy → Web App → Anyone → Copy URL</li><li>Paste URL di bawah lalu klik Sync</li></ol>
          </div>
          <Inp label="URL Google Apps Script" value={sheetsUrl} onChange={e=>setSheetsUrl(e.target.value)} placeholder="https://script.google.com/macros/s/..." />
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:9, marginBottom:12 }}>
            <div style={{ background:"var(--color-background-secondary)", borderRadius:9, padding:12 }}>
              <div style={{ fontSize:11, fontWeight:600, marginBottom:6, color:"var(--color-text-primary)" }}>Data yang di-sync:</div>
              {["✅ Tukang & jadwal","✅ Data klien","✅ Data order","✅ Keuangan","✅ Pembukuan"].map(i=><div key={i} style={{ fontSize:11, padding:"2px 0", color:"var(--color-text-secondary)" }}>{i}</div>)}
            </div>
            <div style={{ background:"#F0FDF4", borderRadius:9, padding:12 }}>
              <div style={{ fontSize:11, fontWeight:600, marginBottom:6, color:"#059669" }}>Sheet yang dibuat:</div>
              {["📋 Dashboard","📋 Tukang","📋 Order","📋 Keuangan","📋 Pembukuan"].map(i=><div key={i} style={{ fontSize:11, padding:"2px 0", color:"var(--color-text-secondary)" }}>{i}</div>)}
            </div>
          </div>
          <Btn label="📤 Sync semua data ke Google Sheets" onClick={async()=>{if(!sheetsUrl){alert("Masukkan URL");return;}try{await fetch(sheetsUrl,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({action:"sync",...data})});alert("✅ Sync berhasil!");}catch{alert("❌ Gagal sync.");}}} style={{ width:"100%", marginBottom:9 }} />
          <div style={{ background:"#FFFBEB", borderRadius:9, padding:10, fontSize:11, color:"#92400E" }}>💡 Untuk rekap otomatis harian, atur trigger di Apps Script setiap hari jam 20:00 WIB.</div>
        </Card>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PENJADWALAN KALENDER
// ─────────────────────────────────────────────
function Jadwal({ data }) {
  const today = new Date();
  const [bln, setBln] = useState(today.getMonth());
  const [thn, setThn] = useState(today.getFullYear());
  const days = new Date(thn,bln+1,0).getDate();
  const first = new Date(thn,bln,1).getDay();
  const namaBln = new Date(thn,bln).toLocaleDateString("id-ID",{month:"long",year:"numeric"});
  const getO = d => { const ds=`${thn}-${String(bln+1).padStart(2,"0")}-${String(d).padStart(2,"0")}`; return data.order.filter(o=>o.tgl===ds); };

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <div style={{ fontSize:18, fontWeight:500, color:"var(--color-text-primary)" }}>Kalender jadwal</div>
        <div style={{ display:"flex", gap:6, alignItems:"center" }}>
          <button onClick={()=>{if(bln===0){setBln(11);setThn(y=>y-1);}else setBln(b=>b-1);}} style={{ background:"var(--color-background-secondary)", border:"none", borderRadius:7, padding:"6px 11px", fontWeight:600, cursor:"pointer", color:"var(--color-text-primary)" }}>◀</button>
          <span style={{ fontSize:12, fontWeight:500, minWidth:130, textAlign:"center", color:"var(--color-text-primary)" }}>{namaBln}</span>
          <button onClick={()=>{if(bln===11){setBln(0);setThn(y=>y+1);}else setBln(b=>b+1);}} style={{ background:"var(--color-background-secondary)", border:"none", borderRadius:7, padding:"6px 11px", fontWeight:600, cursor:"pointer", color:"var(--color-text-primary)" }}>▶</button>
        </div>
      </div>
      <Card style={{ marginBottom:14 }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:2 }}>
          {["Min","Sen","Sel","Rab","Kam","Jum","Sab"].map(d=><div key={d} style={{ padding:5, textAlign:"center", fontSize:10, fontWeight:600, color:"var(--color-text-secondary)" }}>{d}</div>)}
          {Array.from({length:first}).map((_,i)=><div key={"e"+i}/>)}
          {Array.from({length:days}).map((_,i)=>{
            const day=i+1; const orders=getO(day);
            const isT=day===today.getDate()&&bln===today.getMonth()&&thn===today.getFullYear();
            return <div key={day} style={{ minHeight:60, padding:4, border:"0.5px solid var(--color-border-tertiary)", borderRadius:5, background:isT?"#EFF6FF":"var(--color-background-primary)" }}>
              <div style={{ fontSize:11, fontWeight:isT?600:400, color:isT?"#1D4ED8":"var(--color-text-primary)", marginBottom:2 }}>{day}</div>
              {orders.map((o,idx)=><div key={idx} style={{ background:o.status==="Selesai"?"#D1FAE5":o.status==="Berjalan"?"#DBEAFE":"#FEF3C7", color:o.status==="Selesai"?"#059669":o.status==="Berjalan"?"#1D4ED8":"#D97706", borderRadius:3, padding:"1px 3px", fontSize:9, overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis", marginBottom:1 }}>{o.klien}</div>)}
            </div>;
          })}
        </div>
      </Card>
      {data.order.filter(o=>{const d=new Date(o.tgl);return d.getMonth()===bln&&d.getFullYear()===thn;}).map(o=>{
        const hariO=getDayName(o.tgl); const sc=o.status==="Selesai"?"#059669":o.status==="Berjalan"?"#1D4ED8":"#D97706"; const sbg=o.status==="Selesai"?"#D1FAE5":o.status==="Berjalan"?"#DBEAFE":"#FEF3C7";
        return <Card key={o.id} style={{ marginBottom:8 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <span style={{ fontSize:12, fontWeight:600, color:"var(--color-text-primary)" }}>{fd(o.tgl)}</span>
              {hariO&&<span style={{ marginLeft:6, fontSize:11, background:"#F5F3FF", color:"#8B5CF6", padding:"1px 6px", borderRadius:8, fontWeight:600 }}>{hariO}</span>}
              <span style={{ marginLeft:8, fontWeight:500, color:"var(--color-text-primary)" }}>{o.klien}</span>
              <div style={{ fontSize:11, color:"var(--color-text-secondary)", marginTop:2 }}>{o.item}</div>
            </div>
            <span style={{ padding:"2px 9px", borderRadius:12, fontSize:11, fontWeight:600, background:sbg, color:sc }}>{o.status}</span>
          </div>
        </Card>;
      })}
    </div>
  );
}

// ─────────────────────────────────────────────
// MAIN APP
// ─────────────────────────────────────────────
const MENUS = [
  {id:"dashboard",icon:"🏠",label:"Dashboard"},
  {id:"tukang",   icon:"👷",label:"Tukang"},
  {id:"jadwal_tukang",icon:"📅",label:"Jadwal Tukang"},
  {id:"order",    icon:"📦",label:"Order"},
  {id:"kalender", icon:"🗓️", label:"Kalender"},
  {id:"keuangan", icon:"💰",label:"Keuangan"},
  {id:"klien",    icon:"🏢",label:"Klien"},
  {id:"sop",      icon:"📋",label:"SOP"},
  {id:"pembukuan",icon:"📒",label:"Pembukuan"},
  {id:"laporan",  icon:"📊",label:"Laporan"},
];

export default function App() {
  const [menu, setMenu] = useState("dashboard");
  const [data, setData] = useState(INIT);

  const pages = {
    dashboard:    <Dashboard    data={data} />,
    tukang:       <Tukang       data={data} setData={setData} />,
    jadwal_tukang:<JadwalTukang data={data} setData={setData} />,
    order:        <Order        data={data} setData={setData} />,
    kalender:     <Jadwal       data={data} />,
    keuangan:     <Keuangan     data={data} setData={setData} />,
    klien:        <Klien        data={data} setData={setData} />,
    sop:          <SOPChecklist data={data} />,
    pembukuan:    <Pembukuan    data={data} setData={setData} />,
    laporan:      <Laporan      data={data} />,
  };

  return (
    <div style={{ display:"flex", height:"100vh", fontFamily:"'Segoe UI',system-ui,sans-serif", background:"var(--color-background-tertiary)", overflow:"hidden" }}>
      {/* Sidebar */}
      <div style={{ width:190, background:"#0F172A", display:"flex", flexDirection:"column", flexShrink:0, height:"100vh" }}>
        <div style={{ padding:"16px 14px 12px", borderBottom:"1px solid #1E293B" }}>
          <div style={{ color:"#fff", fontWeight:700, fontSize:14 }}>🔧 Rakitin.pro</div>
          <div style={{ color:"#64748B", fontSize:10, marginTop:1 }}>Admin System v3.0</div>
        </div>
        <nav style={{ flex:1, padding:"8px 0", overflowY:"auto" }}>
          {MENUS.map(m=>(
            <button key={m.id} onClick={()=>setMenu(m.id)} style={{ display:"flex", alignItems:"center", gap:9, width:"100%", padding:"9px 14px", background:menu===m.id?"#1D4ED8":"transparent", border:"none", color:menu===m.id?"#fff":"#94A3B8", fontSize:12, fontWeight:menu===m.id?600:400, textAlign:"left", cursor:"pointer" }}>
              <span style={{ fontSize:15, flexShrink:0 }}>{m.icon}</span><span>{m.label}</span>
            </button>
          ))}
        </nav>
        <div style={{ padding:10, borderTop:"1px solid #1E293B", fontSize:9, color:"#475569", textAlign:"center" }}>v3.0 · Jadwal tukang aktif</div>
      </div>
      {/* Main */}
      <div style={{ flex:1, overflowY:"auto", padding:18 }}>
        {pages[menu] || pages.dashboard}
      </div>
    </div>
  );
}
